import React, { useState, useRef, useEffect } from 'react'
import { EMAIL_URLS } from '../lib/share'

const options = [
  { key: 'gmail',   label: 'Gmail',            href: EMAIL_URLS.gmail,   target: '_blank' },
  { key: 'outlook', label: 'Outlook',          href: EMAIL_URLS.outlook, target: '_blank' },
  { key: 'mailto',  label: 'Default Mail App', href: EMAIL_URLS.mailto,  target: '_self'  },
]

const EmailShareButton = ({ className, ariaLabel = 'Share via Email', children, menuAlign = 'right', menuPlacement = 'bottom' }) => {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    if (!open) return
    const onDocClick = (e) => { if (!ref.current?.contains(e.target)) setOpen(false) }
    const onEsc = (e) => { if (e.key === 'Escape') setOpen(false) }
    window.addEventListener('mousedown', onDocClick)
    window.addEventListener('keydown', onEsc)
    return () => {
      window.removeEventListener('mousedown', onDocClick)
      window.removeEventListener('keydown', onEsc)
    }
  }, [open])

  const alignClass = menuAlign === 'left' ? 'left-0' : 'right-0'
  const placementClass = menuPlacement === 'top' ? 'bottom-full mb-2' : 'top-full mt-2'

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className={className}
        aria-label={ariaLabel}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        {children}
      </button>
      {open && (
        <div
          role="menu"
          className={`absolute ${alignClass} ${placementClass} w-44 bg-white rounded-md shadow-lg overflow-hidden z-50 border border-gray-200`}
        >
          {options.map(opt => (
            <a
              key={opt.key}
              role="menuitem"
              href={opt.href}
              target={opt.target}
              rel={opt.target === '_blank' ? 'noopener noreferrer' : undefined}
              onClick={() => setOpen(false)}
              className="block px-3 py-2 text-xs text-gray-800 hover:bg-gray-100 font-poppins"
            >
              {opt.label}
            </a>
          ))}
        </div>
      )}
    </div>
  )
}

export default EmailShareButton
